import script from "./AssignAssignmentToSection.vue?vue&type=script&setup=true&lang=js"
export * from "./AssignAssignmentToSection.vue?vue&type=script&setup=true&lang=js"

import "./AssignAssignmentToSection.vue?vue&type=style&index=0&id=046f33aa&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/prod-fe-app-myqampus/node_modules/vue-cli-plugin-vue-next/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-046f33aa"]])

export default __exports__